module.exports = __webpack_public_path__ + "static/img/timeline-bg.5d9ba85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/timeline-bg.png
// module id = KAwE
// module chunks = 4